import * as yup from 'yup';
import { useI18n } from 'vue-i18n';
import { buildLanguageFields } from '@/core/helpers/yup-validation.helper';
import { useJobBoardStore } from '@/core/collections/job-boards/job-board.store';
import { storeToRefs } from 'pinia';

export function getRules() {
   const { t } = useI18n();
   const jobBoardStore = useJobBoardStore();
   const { currentJobBoard } = storeToRefs(jobBoardStore);

   const languages = currentJobBoard.value?.languages ?? [];
   const languageFields = buildLanguageFields(languages, { max: 255 });

   return yup.object({
      locations: yup.array().of(
         yup.object({
            title: yup.object(languageFields).required(t('live-editor.content-blocks.errors.required')),
            address: yup
               .object()
               .shape({
                  street: yup.string().required(t('live-editor.content-blocks.errors.required')),
                  house_number: yup.string().required(t('live-editor.content-blocks.errors.required')),
                  city_id: yup.string().required(t('live-editor.content-blocks.errors.required')),
               })
               .required(t('live-editor.content-blocks.errors.required')),
            email: yup.string().email(t('live-editor.content-blocks.errors.invalid-email')).nullable(),
         }),
      ),
   });
}
